import { useEffect, useRef, useState } from "react"
import { AppBar, Toolbar, IconButton, Avatar, Tooltip, Box, Badge, Typography } from "@mui/material"
import { useNavigate } from "react-router-dom"
import ShariLogo from "../../assets/images/shariehandslogo.png"
import HomeIcon from "@mui/icons-material/Home"
import { Search } from "@mui/icons-material"
import SearchSkillModal from "../Modals/SearchSkillModal/SearchSkillModal"
import useDeviceType from "../hooks/Utils/useDeviceType"
import NotificationsIcon from "@mui/icons-material/Notifications"
import Notification from "../Notifications/Notifications"
import { useApiService } from "../hooks/Api/useApiService"
import styles from "./NavigationBar.module.css"
import Fade from "@mui/material/Fade"
import { useBusiness } from "../hooks/Contexts/BusinessContext/BusinessContext"
import { keyframes } from "@mui/system"
import Icn from "../UI/SharieIcn/SharieIcn"
import { useUser } from "../hooks/Contexts/UserContext/UserContext"
import useTranslationSharie from "../hooks/Language/useTranslation"
import ChatIcon from "@mui/icons-material/Chat"
import MessensingModal from "../Modals/MessensingModal/MessensingModal"
import CloseIcon from "@mui/icons-material/Close"
import FloatingCircleMenu from "../UI/FloatingCircleMenu"
import MoreHorizIcon from "@mui/icons-material/MoreHoriz"
import { GiPalmTree } from "react-icons/gi"
import { useSocket } from "../hooks/Utils/Socket/SocketManager"
import InsightsIcon from "@mui/icons-material/Insights"

const NavigationBar = ({ isAuthenticated, setIsAuthenticated }) => {
  const [open_notification, setOpenNotification] = useState(false)
  const [notifications, setNotifications] = useState(null)
  const navigate = useNavigate()
  const searchRef = useRef()
  const messengingRef = useRef()
  const t = useTranslationSharie()
  const { postData } = useApiService()
  const [all_r_seen, setAllRSeen] = useState(false)
  const [not_seen_length, setNotSeenLength] = useState(0)
  const deviceType = useDeviceType()
  const initial_icons_state = {
    home: true,
    chat: false,
    notifications: false,
    my_island: false,
  }
  const [not_seen_length_messages, setMessangesLength] = useState(0)
  const [messages_seen, setMessagesSeen] = useState(true)
  const [open, setOpen] = useState(false)
  const [icons_underscore, setIconsUnderscore] = useState(initial_icons_state)
  const [is_menu_open, setIsMenuOpen] = useState(false)
  const [do_vibrate, setDoVibrate] = useState(true)
  const user = localStorage.getItem("user")
  const { updateBusiness } = useBusiness()
  const { updateUser } = useUser()
  const vibrate = keyframes`
  0%, 100% { transform: translateX(0); }
  20%, 80% { transform: translateX(-2px); }
  40%, 60% { transform: translateX(2px); }  `
  const isFromRN =
    typeof window.ReactNativeWebView !== "undefined" || localStorage.getItem("fromRN") === "true"
  const socket = useSocket()

  useEffect(() => {
    setTimeout(() => {
      setDoVibrate(false)
    }, 3000)
    handleClickHome()
  }, [localStorage.getItem("user")])
  useEffect(() => {
    socket?.on("receive_notification", (data) => {
      setNotifications((prev) => [...prev, data.notification])
    })

    return () => {
      socket?.off("receive_notification")
    }
  }, [])
  useEffect(() => {
    if (isAuthenticated) {
      postData("sharie/getnotificationsbyuser", { user_name: user }).then((data) => {
        setNotifications(data?.notifications)
        allAreSeen()
        notSeenLength()
      })
      postData("business/getbusinessbyuser", { user_name: user }).then((data) => {
        updateBusiness(data?.business)
      })
      postData("users/getuser", { user_name: localStorage.getItem("user") }).then((data) => {
        updateUser(data?.user[0])
      })
      postData("sharie/getmessages", { to: localStorage.getItem("user") }).then((data) => {
        if (data?.messages) {
          checkSeenMessages(data?.messages)
        }
      })
    }

    if (open_notification)
      postData("sharie/marknotificationsseen", { notifications: notifications }).then((data) => {})
  }, [open_notification, isAuthenticated])

  useEffect(() => {
    allAreSeen()
    notSeenLength()
  }, [notifications, open_notification])

  const checkSeenMessages = (messages) => {
    setMessagesSeen(true)
    let areallseen = true

    messages?.forEach((element) => {
      if (!element.seen) areallseen = false
    })
    setMessagesSeen(areallseen)

    let count = 0
    messages?.forEach((el) => {
      if (!el.seen) count++
    })
    setMessangesLength(count)
  }

  const openSearchSkillModal = () => {
    if (searchRef.current) {
      searchRef.current.childFunction()
    }
  }
  const openMessengingModal = () => {
    if (messengingRef.current) {
      messengingRef.current.childFunction()
    }
  }
  const allAreSeen = () => {
    let areallseen = true

    notifications?.forEach((element) => {
      if (!element.seen) areallseen = false
    })
    setAllRSeen(areallseen)
  }
  const notSeenLength = () => {
    let count = 0
    notifications?.forEach((el) => {
      if (!el.seen) count++
    })
    setNotSeenLength(count)
  }
  const setOpensFalse = () => {
    setOpenNotification(false)
    setIsMenuOpen(false)
  }
  const handleClickHome = () => {
    setIconsUnderscore((prevState) => ({ ...initial_icons_state, home: true }))
    setOpensFalse()
    window.scrollTo({ top: 0, behavior: "smooth" })
    navigate("/home")
  }

  const handleClickDemands = () => {
    setIsMenuOpen(!is_menu_open)
    setIconsUnderscore((prevState) => ({
      ...initial_icons_state,
      home: false,
      demands: !prevState.demands,
    }))
    navigate("demands")
  }
  const handleClickAccount = () => {
    setIsMenuOpen(!is_menu_open)
    setIconsUnderscore((prevState) => ({
      ...initial_icons_state,
      home: false,
      my_island: !prevState.my_island,
    }))
    navigate("myisland")
  }
  const handleClickNotifications = () => {
    setIconsUnderscore((prevState) => ({
      ...initial_icons_state,
      home: false,
      notifications: !prevState.notifications,
    }))
    setOpenNotification(!open_notification)
    setMessagesSeen(true)
  }

  const handleClickChat = () => {
    setIconsUnderscore((prevState) => ({
      ...initial_icons_state,
      home: false,
      chat: !prevState.chat,
    }))
    setOpensFalse()
    openMessengingModal()
  }
  return (
    <>
      <SearchSkillModal ref={searchRef} />
      <MessensingModal ref={messengingRef} />
      {isAuthenticated && (
        <Fade in={isAuthenticated} timeout={1000}>
          <AppBar position='sticky' className={isFromRN ? styles.appbar_mobile_app : styles.appbar}>
            <Toolbar
              className={isFromRN ? styles.appbar_mobile_app : styles.appbar}
              sx={{ display: "flex", justifyContent: "space-between", alignItems: "space-between" }}
            >
              {/* Left side */}
              <Box className={styles.left_side_box}>
                {isAuthenticated ? (
                  <Icn
                    tooltip='Home'
                    onClick={() => handleClickHome()}
                    label='logo'
                    avatar={<Avatar src={ShariLogo} alt='Icon' className={"shari_logo"} />}
                  />
                ) : (
                  // <Sphere onClick={handleClickHome} />
                  <Avatar src={ShariLogo} alt='Icon' className={styles.shari_logo} />
                )}
                {isAuthenticated && (
                  <Icn
                    color='#1976d2'
                    tooltip='Search'
                    onClick={openSearchSkillModal}
                    label='search'
                    icon={<Search />}
                  />
                )}
              </Box>
              {/* 
              {deviceType === "desktop" && (
                <Box className={styles.running_text_container}>
                  <Typography className={styles.running_text}>
                    {t(
                      "This is Beta version! Let us know if you have any suggestions by clicking on help in your profile."
                    )}
                  </Typography>
                </Box>
              )} */}

              {/* Right icons */}
              {isAuthenticated && (
                <Box className={styles.right_side_box}>
                  {open ? (
                    <Icn
                      tooltip='Close Menu'
                      onClick={() => setOpen((prev) => !prev)}
                      label='close menu'
                      icon={<CloseIcon />} // or a plus/menu icon
                    />
                  ) : (
                    <Icn
                      tooltip='Open Menu'
                      onClick={() => setOpen((prev) => !prev)}
                      label='open menu'
                      icon={<MoreHorizIcon />} // or a plus/menu icon
                    />
                  )}

                  <FloatingCircleMenu open={open} setOpen={setOpen} setOpensFalse={setOpensFalse} />
                  <Icn
                    tooltip='Home'
                    color='inherit'
                    onClick={handleClickHome}
                    label='home'
                    icon={<HomeIcon />}
                    className={icons_underscore.home ? "icons_underscore" : ""}
                  />
                  <Icn
                    tooltip='Demands'
                    color='inherit'
                    onClick={handleClickDemands}
                    label='demands'
                    icon={<InsightsIcon />}
                    className={icons_underscore.demands ? "icons_underscore" : ""}
                  />
                  {messages_seen ? (
                    <Badge
                      badgeContent={not_seen_length_messages}
                      color='error'
                      overlap='circular'
                      anchorOrigin={{
                        vertical: "top",
                        horizontal: "right",
                      }}
                    >
                      <Icn
                        tooltip='Chat'
                        color='inherit'
                        onClick={handleClickChat}
                        label='chat'
                        icon={<ChatIcon />}
                        className={icons_underscore.chat ? "icons_underscore" : ""}
                      />
                    </Badge>
                  ) : (
                    <Icn
                      tooltip='Chat'
                      color='inherit'
                      onClick={handleClickChat}
                      label='chat'
                      icon={<ChatIcon />}
                      className={icons_underscore.chat ? "icons_underscore" : ""}
                    />
                  )}
                  <Icn
                    tooltip='My Island'
                    color='inherit'
                    onClick={handleClickAccount}
                    label='myisland'
                    icon={<GiPalmTree />}
                    className={icons_underscore.my_island ? "icons_underscore" : ""}
                  />

                  <Tooltip
                    className={
                      deviceType === "desktop"
                        ? styles.notification_icon_desktop
                        : styles.notification_icon_mobile
                    }
                    arrow
                    title={t("Notifications")}
                  >
                    <IconButton
                      className={open_notification ? styles.icons_underscore : ""}
                      color='inherit'
                      onClick={handleClickNotifications}
                    >
                      {!all_r_seen ? (
                        <Badge
                          badgeContent={not_seen_length}
                          color='error'
                          overlap='circular'
                          anchorOrigin={{
                            vertical: "top",
                            horizontal: "right",
                          }}
                        >
                          <NotificationsIcon />
                        </Badge>
                      ) : (
                        <NotificationsIcon />
                      )}
                    </IconButton>
                  </Tooltip>
                </Box>
              )}
            </Toolbar>
          </AppBar>
        </Fade>
      )}

      {open_notification && <Notification notifications={notifications} deviceType={deviceType} />}
    </>
  )
}

export default NavigationBar
